import { render, staticRenderFns } from "./SelectCard.vue?vue&type=template&id=70e48c58&scoped=true&"
import script from "./SelectCard.vue?vue&type=script&lang=js&"
export * from "./SelectCard.vue?vue&type=script&lang=js&"
import style0 from "./SelectCard.vue?vue&type=style&index=0&id=70e48c58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e48c58",
  null
  
)

export default component.exports